module.exports = __webpack_public_path__ + "dist/media/verified.06c33792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/verified.png
// module id = 364
// module chunks = 0